import React from 'react'
import { SelectOptionsWMO } from '../../../style/QuantitySelectionWMO.css'

const QuantitySelectionWMO = props => {
  const {
    eligibleRMA,
    partNumber,
    setQtyRange,
    handleQtyChange,
    ikey,
    qtyRange,
    qtyToCompute,
  } = { ...props }

  const options = setQtyRange(qtyRange)
  const filteredOptions = options.filter((option) => qtyToCompute !== option)
  const isDisable = !eligibleRMA || !filteredOptions.length;

  return (
    <SelectOptionsWMO
      id={eligibleRMA ? `qty-${partNumber}`: `qty-${partNumber}${ikey}`}
      style={{ width: '100%' }}
      options={filteredOptions}
      value={qtyToCompute}
      justify="start"
      onChange={({ option }) => handleQtyChange(option)}
      disabled={isDisable} 
      placeholder={qtyToCompute ? `${qtyToCompute}` : 'Select an option'}
    />
  )
}

export default QuantitySelectionWMO
